import * as React from "react";

const SvgComponent = (props) => (
  <svg width={18} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 2h-1V0h-2v2H5V0H3v2H2C.89 2 .01 2.9.01 4L0 18a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 16H2V8h14v10Zm0-12H2V4h14v2Zm-7 5h5v5H9v-5Z"
      fill="#4F4F4F"
    />
  </svg>
);

export default SvgComponent;
